import { useEffect } from 'react';

import PrivacyPolicyIcon from '@/assets/all-icons/privacy-policies-icon';
import useTranslations from '@/i18n/useTranslations';
import FormError from '@/shared-components/error/components/FormError';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';
import Heading from '@/shared-components/text/components/Heading';
import Text from '@/shared-components/text/components/Text';

import './styles/ShippingCard.css';

export default function ShippingCard({
  value,
  location,
  element,
  formError,
  previewMode,
  onChange,
  deleteException,
  currency = null,
  disabled = false
}) {
  const t = useTranslations('common.forms.add_artwork');
  useEffect(() => {
    if (currency) {
      onChange({ ...value, currency });
    }
  }, [currency]);

  const outerCls = `add-artwork-shipping__shipping-card-outter ${
    disabled ? 'read-only' : ''
  }`;

  return (
    <div className={outerCls}>
      <div
        className={`add-artwork-shipping__shipping-card ${
          value.payer === 'My gallery' ? ' my-gallery' : ''
        }`}
        id={element}
      >
        {/* Candado cuando no hay permisos */}
        {disabled && (
          <PrivacyPolicyIcon className="add-artwork-shipping__lock-icon" />
        )}

        {(deleteException && !previewMode && !disabled) && (
          <div
            className="add-artwork-shipping__shipping_card-delete"
            onClick={deleteException}
          >
            <div />
          </div>
        )}

        <h2 className="add-artwork-shipping__shipping-card-location">
          <Heading className="add-artwork-shipping__shipping-card-location-text">{location}</Heading>
        </h2>

        <Text
          className="add-artwork-shipping__shipping-card-text"
          paragraph
          justify>
          {t('shipping.who_pays')}
        </Text>

        <PublicFormInput
          className="add-artwork-shipping__shipping-card-choose"
          type="choose"
          optionA="The collector"
          optionAText={t('shipping.collector')}
          optionB="My gallery"
          optionBText={t('shipping.my_gallery')}
          value={value.payer}
          onChange={(payer) =>
            onChange(
              payer === 'My gallery'
                ? { ...value, payer, currency, price: '' }
                : { ...value, payer }
            )
          }
        />

        {value.payer !== 'My gallery' && (
          <div
            className={`add-artwork-shipping__shipping-card-group${
              value.payer === 'My gallery' ? ' disabled' : ''
            }`}
          >
            <div className="add-artwork-shipping__shipping-card-group-entire">
              <PublicFormInput
                placeholder={t('shipping.price')}
                type="currencyInput"
                element={`${element}_price`}
                value={value.price}
                onChange={(e) =>
                  onChange({ ...value, price: e.target.value })
                }
                currency={currency}
              />
            </div>
          </div>
        )}
      </div>
      <FormError
        error={
          Array.isArray(formError)
            ? formError.find((err) => err.element === element)
            : null
        }
        element={element}
        errorClassName="add-artwork-shipping-error"
      />
    </div>
  );
}
